import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import About from './pages/About';
import FulaniHistory from './pages/FulaniHistory';
import Contact from './pages/Contact';
import { FaHome, FaQuestionCircle, FaInfoCircle, FaHistory, FaEnvelope } from 'react-icons/fa';

// Create a wrapper component to access location
const AppContent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const categories = [
    { id: 'greetings', name: 'Greetings', icon: '👋' },
    { id: 'introduction', name: 'Introduction', icon: '👨‍💼' },
    { id: 'family', name: 'Family', icon: '👨‍👩‍👧‍👦' },
    { id: 'places', name: 'Places & Things', icon: '🏠' },
    { id: 'food', name: 'Food', icon: '🍲' },
    { id: 'body', name: 'Body', icon: '👤' },
    { id: 'shopping', name: 'Shopping', icon: '🛍️' },
    { id: 'travel', name: 'Travel', icon: '✈️' },
    { id: 'daily', name: 'Daily Activities', icon: '📅' },
    { id: 'ceremonies', name: 'Ceremonies', icon: '🎉' },
    { id: 'fable', name: 'Fables', icon: '📚' },
    { id: 'advice', name: 'Useful Advice', icon: '💡' },
    { id: 'oral', name: 'Oral History', icon: '🗣️' },
    { id: 'stative', name: 'Stative Verbs', icon: '⚡' },
    { id: 'active', name: 'Active Verbs', icon: '🏃' }
  ];

  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-brand">
          <Link to="/">Learn Pulaar</Link>
        </div>
        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>
            <FaHome /> Home
          </Link>
          <Link to="/quiz" onClick={() => setIsMenuOpen(false)}>
            <FaQuestionCircle /> Quiz
          </Link>
          <Link to="/about" onClick={() => setIsMenuOpen(false)}>
            <FaInfoCircle /> About
          </Link>
          <Link to="/history" onClick={() => setIsMenuOpen(false)}>
            <FaHistory /> Fulani History
          </Link>
          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
            <FaEnvelope /> Contact
          </Link>
        </div>
      </nav>

      <div className="page-container">
        {isHomePage && (
          <div className="sidebar">
            <h2>Explore Categories</h2>
            <div className="category-list">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => handleCategorySelect(category.id)}
                >
                  <span className="category-icon">{category.icon}</span>
                  <span className="category-name">{category.name}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        <div className={`main-content ${!isHomePage ? 'full-width' : ''}`}>
          <Routes>
            <Route path="/" element={<Home selectedCategory={selectedCategory} onSelectCategory={handleCategorySelect} />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/about" element={<About />} />
            <Route path="/history" element={<FulaniHistory />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
